import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext, onCurrentJobSelectionChange } from './ProfessionalPracticeActions';
import { onPrimaryCurrentChange } from '../primaryCurrentJob';
import ProfessionalPracticeLayout from './ProfessionalPracticeLayout';
import CurrentJobInformationLayout from '../CurrentJobInformationLayout';
import ProfilePicturePageConfig from '../ProfilePicturePageConfig.json';

const ProfessionalPractice = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

    const location = useLocation();
    const currentMatch = location.pathname.includes('current')

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isCurrent: onCurrentJobSelectionChange,
            isPrimaryCurrent: onPrimaryCurrentChange('professionalPractice'),
            REDIRECT: setRedirectUrl,
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

        const jobRoleCodeDomain = domain.get('JOB_ROLE_CODE');
        if (jobRoleCodeDomain) {
            const filteredJobRoleCode = jobRoleCodeDomain.filter((role) => role.code !== 'VISITING_FACULTY');
            domain.set('JOB_ROLE_CODE', filteredJobRoleCode);
        }

        // data['professionalPractice'] = data['professionalPractice'] ?? {};

        // This code for Profile Picture Section from config----------
            let updatedFormConfig: any = { ...formConfig };
            console.log("currentMatch",currentMatch)
            if (currentMatch) {
                const rawProfileSection =
                    ProfilePicturePageConfig.sectionRepository.find(
                        (sec: any) => sec.id === "profile"
                    );
                console.log("rawProfileSection",rawProfileSection)
                if (rawProfileSection && !updatedFormConfig.sections?.includes("profile")) {
                    updatedFormConfig = {
                        ...updatedFormConfig,
                        sections: [...(updatedFormConfig.sections ?? []), "profile"],
                        sectionRepository: [
                            ...(updatedFormConfig.sectionRepository ?? []),
                            rawProfileSection as any
                        ],
                    };
                }
            }
            // end here

        const updatedprofessionalPracticeWork = (data?.professionalPractice?.length
                ? data.professionalPractice
                : [{}]
            ).map((job: any) => ({
                ...job,
                isCurrent: currentMatch ?  true : job?.isCurrent ?? 0
            }));

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig: updatedFormConfig,
                data: {
                    ...data,
                    professionalPractice: updatedprofessionalPracticeWork,
                    currentMatch
                },
                domain,
                routeInfo,
            },
        });
    }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    let message = (currentMatch) ? `Since you mentioned you are currently running your Professional Practice, please provide the details.`
    : `In your work status, you mentioned that you are currently running your professional practice. Please provide the details of your practice.`
    const LayoutComponent = currentMatch ? CurrentJobInformationLayout : ProfessionalPracticeLayout;

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder data={message} />}</LayoutComponent>
            {/* <ProfessionalPracticeLayout>{!state.flags.isDataLoading && <PageBuilder data={message}/>}</ProfessionalPracticeLayout> */}
        </SmartContext.Provider>
    );
};

export default ProfessionalPractice;
